import { useQuery } from "@tanstack/react-query";
import { useActiveOrg } from "@/features/tenancy/hooks";
import { fetchFeatureAccess, fetchModuleAccess, fetchPlan } from "./api";

const CINCO_MINUTOS = 5 * 60_000;

export function useModuleAccess() {
  const { org } = useActiveOrg();
  const orgId = org?.organizationId ?? null;

  return useQuery({
    queryKey: ["module-access", orgId],
    queryFn: () => fetchModuleAccess(orgId!),
    enabled: Boolean(orgId),
    staleTime: CINCO_MINUTOS,
  });
}

export function useFeatures() {
  const { org } = useActiveOrg();
  const orgId = org?.organizationId ?? null;

  return useQuery({
    queryKey: ["features", orgId],
    queryFn: () => fetchFeatureAccess(orgId!),
    enabled: Boolean(orgId),
    staleTime: CINCO_MINUTOS,
  });
}

export function usePlan() {
  const { org } = useActiveOrg();
  const orgId = org?.organizationId ?? null;

  return useQuery({
    queryKey: ["plan", orgId],
    queryFn: () => fetchPlan(orgId!),
    enabled: Boolean(orgId),
    staleTime: CINCO_MINUTOS,
  });
}

/**
 * Si el plan de la tienda incluye una capacidad.
 *
 * Mientras carga devuelve `false`: es preferible que un boton aparezca un
 * instante despues a que se pueda pulsar durante medio segundo algo que la
 * base va a rechazar.
 */
export function useFeature(key: string): boolean {
  const { data } = useFeatures();
  return (data ?? []).some((f) => f.key === key && f.incluida);
}
